<template>
    <!-- <div class="page-header">
        <div class="form-row">
            <div class="form-group col-md-12"><h3>{{addOrEdit ? 'Edit' : 'Add New'}} Product</h3></div>
        </div>
    </div> -->
    <CommonHeader class="main_head_block">
		<template v-slot:header>
		<span class="module_heading">{{addOrEdit ? 'Edit' : 'Add New'}} Product</span>
        </template>
	</CommonHeader>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
export default {
    components:{CommonHeader},
    computed: {
        addOrEdit: {
            get() {
                let editSelectedProduct = this.$store.state.product.editSelectedProduct
                let productId = this.$route.params.productId
                let isForEdit = editSelectedProduct && editSelectedProduct.id && editSelectedProduct.id == productId
                isForEdit = isForEdit || (productId > -1)
                return isForEdit
            }
        },
    }
}
</script>

<style lang="scss">

</style>
